import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShellComponent } from '../app/core/shell/shell.component';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginComponent } from './core/login/login.component';
import { NotFoundComponent } from './core/not-found/not-found.component';
import { SettingsResolver } from './core/app-settings/resolver/settings.resolver';
import { ConfigurationResolver } from './core/resolvers/configuration.resolver';
import { REDIRECT_URL } from './shared/constants/redirect-route.constants';
import { CONTENT_ROUTES_PATHS } from './shared/constants/contents.constants';
 
const routes: Routes = [
  {
    path: CONTENT_ROUTES_PATHS.LOGIN,
    component: LoginComponent,
    resolve: {
      settings: SettingsResolver, // Resolver for settings to be loaded before login page is loaded
      configs: ConfigurationResolver // Resolver for configurations to be loaded before login page is loaded
    },
  },
  {
    path: '',
    component: ShellComponent,
    resolve: {
      settings: SettingsResolver,
      configs: ConfigurationResolver
    },
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: REDIRECT_URL, pathMatch: 'full' },
      {
        path: CONTENT_ROUTES_PATHS.PLAYER_INFORMATION,
        loadChildren: () =>
          import('./modules/player-information/player-information.module').then(
            (m) => m.PlayerInformationModule
          ),
      },
      {
        path: CONTENT_ROUTES_PATHS.ACCOUNT_SECURITY,
        loadChildren: () => import('./modules/account-security/account-security.module').then(
          (m) => m.AccountSecurityModule
        )
      },
      {
        path: CONTENT_ROUTES_PATHS.OFFERS + '/:parentRoute/:sectionName',
        loadChildren: () => import('./modules/offers/offers.module').then((module) => module.OffersModule)
      },
      {
        path: CONTENT_ROUTES_PATHS.WIN_LOSS_STATEMENT,
        loadChildren: () => import('./modules/win-loss-statement/win-loss-statement.module').then(
          (m) => m.WinLossStatementModule
        )
      },
      {
        path: CONTENT_ROUTES_PATHS.RSVPOFFERS + '/:parentRoute/:sectionName',
        loadChildren: () => import('./modules/rsvp-offers/rsvp-offers.module').then((module) => module.RsvpOffersModule)
      },
      {
        path: CONTENT_ROUTES_PATHS.DYNAMIC_CONTENT + '/:sectionName',
        loadChildren: () => import('./modules/dynamic-content/dynamic-content.module').then(
          (m) => m.DynamicContentModule
        )
      }
    ],
  },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
 
@NgModule({
  imports: [RouterModule.forRoot(routes,{scrollPositionRestoration: 'top', anchorScrolling:'enabled'})],
  exports: [RouterModule],
})
export class AppRoutingModule {}